var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1369_2473",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.926758,
    y: 0.720154,
    width: 21.9,
    height: 24.0825,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1369_2473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.57481 17.8756C6.40559 17.8756 6.26373 17.823 6.14926 17.7178C6.03478 17.6125 5.97754 17.4821 5.97754 17.3264C5.97754 17.1708 6.03478 17.0405 6.14926 16.9354C6.26373 16.8303 6.40559 16.7777 6.57481 16.7777H7.41713V11.3161C7.41713 10.3317 7.74767 9.46129 8.40874 8.70492C9.06983 7.94855 9.91852 7.4648 10.9548 7.25366V6.79759C10.9548 6.54344 11.0515 6.32741 11.2449 6.14951C11.4383 5.97159 11.6731 5.88263 11.9494 5.88263C12.2256 5.88263 12.4607 5.97159 12.6547 6.14951C12.8487 6.32741 12.9457 6.54344 12.9457 6.79759V7.25366C13.982 7.4648 14.8307 7.94855 15.4918 8.70492C16.1528 9.46129 16.4834 10.3317 16.4834 11.3161V16.7777H17.3257C17.4949 16.7777 17.6368 16.8304 17.7513 16.9356C17.8657 17.0409 17.923 17.1713 17.923 17.3269C17.923 17.4825 17.8657 17.6129 17.7513 17.718C17.6368 17.8231 17.4949 17.8756 17.3257 17.8756H6.57481ZM11.9489 19.9308C11.5526 19.9308 11.2139 19.8012 10.9326 19.5421C10.6513 19.283 10.5107 18.9715 10.5107 18.6076H13.3898C13.3898 18.9727 13.2487 19.2844 12.9666 19.543C12.6844 19.8015 12.3452 19.9308 11.9489 19.9308ZM8.61164 16.7777H15.2889V11.3161C15.2889 10.4687 14.9629 9.74539 14.311 9.14621C13.6591 8.54702 12.8722 8.24742 11.9503 8.24742C11.0283 8.24742 10.2414 8.54702 9.58949 9.14621C8.93759 9.74539 8.61164 10.4687 8.61164 11.3161V16.7777Z",
    fill: "#808080"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiIcon);
export default __webpack_public_path__ + "static/media/NotiIcon.adf091db2718c3db75142bef8920f5ce.svg";
export { ForwardRef as ReactComponent };